export default __webpack_public_path__ + "static/hero-banner-c4e43cba6b841332455954354c927123.png";